import React from "react";
import "../../styles/SuccessInMotion.scss";
import FloatingBalls from "../../components/Background/FloatingBalls";

export default function SuccessInMotion() {
  return (
    <div className="sm-wrapper">
      <header className="sm-header">
        <div className="sm-header-bg" />       
        <div className="sm-header-content">
            <h1 className="sim-title sm-cutout-text" data-text="Success">Success</h1>
            <h1 className="sim-title sm-cutout-text" data-text="In Motion">In Motion</h1>
            <h2 className="sim-title sm-cutout-text sub"  data-text="Inonovate. Inspire. Impact.">Innovate. Inspire. Impact.</h2>
        </div>
      </header>

      <section className="sm-section">
        <FloatingBalls />
        <div className="blur-overlay"></div>

        <div className="sm-container">
          <h2 className="sm-title-1">Success in Motion:</h2>
          <h2 className="sm-title-2">Innovate. Inspire. Impact. </h2>

          <p>
            Every generation faces a turning point — a moment when progress demands courage, 
            creativity, and collaboration. In the life insurance profession, that moment is now.
          </p>

          <p>
            <b>Success in Motion</b> is more than a theme — it’s a movement. It represents the 
            collective momentum of financial professionals who are constantly evolving, breaking 
            barriers, and shaping the future of the industry. It speaks to those who believe that 
            success isn’t about standing still; it’s about moving forward with purpose, resilience, 
            and vision.
          </p>

          <p>
            In 2027, the Philippines will proudly host the 21st Asia Pacific Life
            Insurance Congress — themed “Success in Motion: Innovate, Inspire, Impact.”
            This milestone event will celebrate the industry’s shared vision of progress,
            resilience, and leadership in an ever-evolving financial landscape.
          </p>

          <p>
            As the world continues to change, the role of life insurance professionals has never 
            been more vital. We are innovators who embrace technology and new thinking. We are 
            inspirers who uplift teams and communities. And we are impact-makers who build 
            security and confidence for millions of families across the Asia-Pacific.
          </p>
          <p>
            Through the theme <b>“Success in Motion: Innovate. Inspire. Impact.”</b>, the <b>21st Asia
            Pacific Life Insurance Congress (APLIC 2027)</b> celebrates the dynamic spirit of 
            today’s leaders — individuals and organizations driven to make a difference. It’s a call 
            to reignite passion, to reimagine success, and to move together toward a future of 
            greater possibilities.
          </p>
          <p>
            When the Philippines hosts APLIC 2027, the entire region will come together to honor 
            the unstoppable energy of the profession — a community of dreamers, doers, and 
            game-changers creating lasting impact in motion.
          </p>
          <p>
            Because success isn’t just a destination — it’s a journey that never stops moving forward.
          </p>
        </div>
      </section>
    </div>
  );
}
